import { FrameworkConfig } from "fw";

// components

import { TextFormField } from "views/components/form/text-form-field";
import { TextareaFormField } from "views/components/form/textarea-form-field";
import { FileFormField } from "views/components/form/file-form-field";
import { DropdownFormField } from "views/components/form/dropdown-form-field";
import { Validation } from "views/components/form/validation";
import { AtsLoginButton } from "views/components/ats-login-button";
import { FormattedDate } from "views/components/formatted-date";
import { Duration } from "views/components/duration";
import { Icon } from "views/components/icon";

import { AdmissionsHeader } from "./views/header/admissions-header";
import { Notifications } from "./components/notifications/notifications";
import { Tooltip } from "./components/tooltip";
import { ToggleFormField } from "views/components/form/toggle-form-field";

export function registerComponents(c: FrameworkConfig) {
    c.registerComponents(
        TextareaFormField,
        TextFormField,
        FileFormField,
        DropdownFormField,
        ToggleFormField,
        Validation,
        AtsLoginButton,
        FormattedDate,
        Duration,
        Icon,
        AdmissionsHeader,
        Notifications,
        Tooltip
    );
}
